const ItemType = require('@/lib/Items/ItemType');

/**
 * The Font Awesome icon class to use when showing an icon for each item type.
 * These are defined in the reference at https://digitickets.github.io/icons.html
 * All of these need fa-solid alongside them,
 *
 * @type {Object<string, string>}
 */
const ItemTypeIcons = Object.freeze({
    [ItemType.BUNDLE]: 'fa-boxes-stacked',
    [ItemType.DELIVERY_METHOD]: 'fa-truck',
    [ItemType.GENERIC]: 'fa-shapes',
    [ItemType.GIFT_VOUCHER]: 'fa-gift',
    [ItemType.ITEM_OPTION]: 'fa-layer-plus',
    // Note the reference says to use fa-ballot for membership plans, but we almost always mean a membership here.
    [ItemType.MEMBERSHIP_PLAN]: 'fa-users',
    [ItemType.PRODUCT]: 'fa-box-taped',
    [ItemType.PRODUCT_FOOD]: 'fa-burger-cheese',
    [ItemType.PRODUCT_KITCHEN]: 'fa-fork-knife',
    [ItemType.SURCHARGE]: 'fa-plus',
    [ItemType.TICKET]: 'fa-ticket-simple',
});

const DEFAULT_ITEM_TYPE_ICON = 'fa-circle-question';

module.exports = {
    ItemTypeIcons,
    DEFAULT_ITEM_TYPE_ICON,
};
